import React, { useContext, useRef } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import { PathPolicyHome, PathPolicyPage } from '.'
import { FeaturesEnum } from '../../../utils/features'
import CustomPlanCTA from '../../components/CustomPlan'
import type { PathPolicySideMenuRef } from '../../components/PathPolicy'
import { PathPolicySideMenu } from '../../components/PathPolicy'
import { BaseLayout } from '../../layouts'
import { UserContext } from '../../providers'

const PathPolicyRouter = (): React.ReactElement => {
  const { path } = useRouteMatch()
  const sideMenuRef = useRef<PathPolicySideMenuRef>(null)

  const { user } = useContext(UserContext)

  return user?.pricingPlan.featuresList.includes(FeaturesEnum.PATH_POLICY) ? (
    <BaseLayout menu={<PathPolicySideMenu ref={sideMenuRef} />}>
      <Switch>
        <Route path={`${path}`} component={PathPolicyHome} exact />
        <Route path={`${path}/:pathPolicyId`} exact>
          <PathPolicyPage sideMenuRef={sideMenuRef} />
        </Route>
      </Switch>
    </BaseLayout>
  ) : (
    <BaseLayout>
      <CustomPlanCTA feature={FeaturesEnum.PATH_POLICY} />
    </BaseLayout>
  )
}

export default PathPolicyRouter
